/** Shared by the generation records list and its per-video process page — one place for how a nullable field prints. */

export function formatOptional(value) {
  return value === null || value === '' ? '-' : value
}

export function formatDate(value) {
  return value === null ? '-' : new Date(value).toLocaleString()
}

export function formatSize(value) {
  if (value === null) return '-'
  if (value < 1024) return `${value} B`
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`
  return `${(value / 1024 / 1024).toFixed(1)} MB`
}

/** Milliseconds as a human span: `12.3s`, `4m 05s`, `1h 20m`. Provider calls run for tens of minutes, so seconds alone don't read. */
export function formatDuration(value) {
  if (value === null) return '-'
  const totalSeconds = Math.round(value / 1000)
  if (totalSeconds < 60) return `${(value / 1000).toFixed(1)}s`
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  if (hours === 0) return `${minutes}m ${String(seconds).padStart(2, '0')}s`
  return `${hours}h ${String(minutes).padStart(2, '0')}m`
}

/** Span between two timestamps, or `-` when either side hasn't happened yet. */
export function formatElapsed(from, to) {
  if (from === null || to === null) return '-'
  return formatDuration(new Date(to).getTime() - new Date(from).getTime())
}

export function statusVariant(status) {
  switch (status) {
    case 'queued':
      return 'neutral'
    case 'running':
      return 'info'
    case 'ready':
      return 'success'
    case 'failed':
      return 'danger'
    default:
      throw new Error(`Unhandled generation record status: ${status}`)
  }
}
